// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("./img/checked.svg", import.meta.url);
// Module
var code = `<div class="item-content">
  <div class="item-name-section">
    <div class="item-name-container">
      <div class="item-name-text">\${this.name}</div>
    </div>
  </div>
  <div class="item-check-container">
    <div class="check-icon">
      <img src="${___HTML_LOADER_IMPORT_0___}" alt="selected">
    </div>
  </div>
</div>
`;
// Exports
export default code;